import Vue from 'vue'
let vue = new Vue()
let baseUrl = vue.$cdn

export default{
  introduce: {
    title: ['四维看看 Lite', '全球首款 消费级3D空间相机'],
    price: 'RMB 3,999',
    dec: '10分钟复刻空间（100m²），时间仅需传统设备的1/20，4K高清画质，快速实现沉浸式3D实景空间漫游。',
    btn: '立即购买',
    subTitle: '3D实景复刻神器',
    benefitGroup: [
      {
        fontImg: 'icon-koudai',
        icon: baseUrl + 'images/product_img_02_a@2x.png',
        title: '轻便易携 装进口袋',
        content:
            '机身体积与普通手机无异， <br>重量为115克，<br>仅为同类型产品重量的1/30。'
      },
      {
        fontImg: 'icon-jianmo',
        icon: baseUrl + 'images/product_img_02_b@2x.png',
        title: '轻松操作 高效建模',
        content:
            '无需具备专业知识，10分钟即可采集<br>100平米空间数据，一键上传云端系统， <br>5分钟自动生成模型。'
      },
      {
        fontImg: 'icon-manyou',
        icon: baseUrl + 'images/product_img_02_c@2x.png',
        title: '高精还原 空间漫游',
        content:
            '720°无死角复刻3D实景， <br>呈现4K高清画质， <br>实现沉浸式空间漫游。'
      },
      {
        fontImg: 'icon-paise',
        icon: baseUrl + 'images/product_img_02_d@2x.png',
        title: '室内室外 皆可拍摄',
        content:
            '攻克同类型设备无法采集室外数据<br>的技术难点，使得3D数据采集<br>不再受地点限制，室内室外皆可完成。'
      },
      {
        fontImg: 'icon-genxing',
        icon: baseUrl + 'images/product_img_02_e@2x.png',
        title: '自由编辑 随时更新',
        content:
            '贴心打造模型编辑平台<br>支持图文、 视频、 链接等信息热点的<br>添加及更新。'
      }
    ]
  },
  app: {
    title: '4DKankan App',
    sub: ['快速编辑和分享你的互动式视频', '分享你的空间故事']
  },
  guide: [
    {
      title: [
        '高清还原，身临其境',
        'AI空间重构算法，精准还原实景空间，带给您如临现场的空间漫游体验。'
      ]
    },
    {
      title: ['三步轻松复刻空间', '连接相机、拍摄及完成上传流程后，完成空间复刻。轻松<br/>上手，无需专业培训。'],
      sub: ['上传至云端计算', '四维看看Lite拍摄', '用户端空间展示']
    },
    {
      title: ['3D空间即时自动生成', '10分钟即可采集100㎡的空间数据，5分钟自动生成3D空间。']
    },
    {
      title: ['编辑和分享互动3D空间', '支持在3D空间中增加多媒体热点，可支持图像、文字、超链接、语音<br/>导览等功能，轻松加入“淘宝链接”。']
    }
  ],
  technology: {
    title: '精密智造，精致轻巧',
    dec: '由多达892个精密元件组装而成，超细腻喷涂工艺。'
  },
  parmas: {
    name: '四维看看 Lite 详细参数'
  },
  standardGroup: {
    label: '型号',
    name: '四维看看 Lite',
    info: [
      {
        label: '高度',
        value: '130mm'
      },
      {
        label: '宽度',
        value: '47mm'
      },
      {
        label: '厚度',
        value: '18mm'
      },
      {
        label: '重量',
        value: '115g'
      }
    ],
    params1: [
      {
        label: '材质',
        value: ['钛金属', '磨砂背']
      },
      {
        label: '摄像头',
        value: [
          'f / 2.0 大光圈镜头',
          '3200万像素SONY sensor',
          '220°双鱼眼镜头',
          '9片8组光学镜头',
          '3K视频录制速度为30fps'
        ]
      },
      {
        label: '连接',
        value: ['蓝牙：5.0', 'WiFi：802.11a / b / g / n / ac']
      }
    ],
    params2: [
      {
        label: '电池',
        value: ['2000mAh', '通过USB快速充电']
      },
      {
        label: '存储',
        value: ['支持128G TF卡', '3K视频 录制120分钟']
      },
      {
        label: '端口',
        value: ['microUSB', '三脚架固定孔']
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/store/language/cn/binocular.js